import type {PropsWithChildren} from 'react'
import React from 'react'

import {useMapComponent} from '../lib'
import type * as t from '../model'

export {MapClusterer} from './map-clusterer'
export {
  getGeolocationFromBrowser,
  getGeolocationPermission,
  MapGeolocationCustomControl,
  MapIcon,
} from './map-geolocation-custom-control'
export {MapZoomCustomControl} from './map-zoom-custom-control'

export const MapControl: React.FC<PropsWithChildren<t.MapControlProps>> = props => {
  const MapComponent = useMapComponent<PropsWithChildren<t.MapControlProps>>('YMapControl')
  return MapComponent && <MapComponent {...props} />
}

export const MapMarker: React.FC<PropsWithChildren<t.MapMarkerProps>> = props => {
  const MapComponent = useMapComponent<t.MapMarkerProps>('YMapMarker')
  // aalebedev-6. пропс draggable не реактивен
  const {draggable} = props
  return MapComponent && <MapComponent key={String(draggable)} {...props} />
}

export const MapControls: React.FC<PropsWithChildren<t.MapControlsProps>> = props => {
  const MapComponent = useMapComponent<t.MapControlsProps>('YMapControls')
  return MapComponent && <MapComponent {...props} />
}
export const MapFeature: React.FC<PropsWithChildren<t.MapFeatureProps>> = props => {
  const MapComponent = useMapComponent<t.MapFeatureProps>('YMapFeature')
  return MapComponent && <MapComponent {...props} />
}
export const MapGeolocationControl: React.FC<t.MapGeolocationControlProps> = props => {
  const MapComponent = useMapComponent<t.MapGeolocationControlProps>('YMapGeolocationControl')
  return MapComponent && <MapComponent {...props} />
}
export const MapListener: React.FC<PropsWithChildren<t.MapListenerProps>> = props => {
  const MapComponent = useMapComponent<t.MapListenerProps>('YMapListener')
  return MapComponent && <MapComponent {...props} />
}
export const MapZoomControl: React.FC<t.MapZoomControlProps> = props => {
  const MapComponent = useMapComponent<t.MapZoomControlProps>('YMapZoomControl')
  return MapComponent && <MapComponent {...props} />
}

export {Map, useMapRef} from './map'
export type {OnBoundsChangeArg, OnBoundsChangeType} from './route'
export {Route} from './route'
export {ShowError} from './show-error'
